// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__adRW1","gfeWrapper":"CalendarEvent_gfeWrapper__3O9ET"};